import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-700 py-4">
      <button
        className="flex justify-between items-center w-full text-left text-lg font-semibold text-white hover:text-blue-400"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {question}
        {isOpen ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
      </button>
      {isOpen && (
        <p className="mt-2 text-gray-200 text-base">{answer}</p>
      )}
    </div>
  );
};

const FAQPage = () => {
  const faqs = [
    {
      question: 'How to register to an event?',
      answer:
        'To register for an event, navigate to the Events page, select on the event you want to join , and click the "Join" button. Also make sure to check the events detatils too.',
    },
    {
      question: 'How to post on the site?',
      answer:
        'Click on "Share an event" Simply forward your event details to Our Whatsapp Bot. Make sure to Inculde all the details in the message',
    },
    {
      question: 'How to get verified?',
      answer:
        'To get verified, contact via the Contact page with proof of your organization’s legitimacy. will review your submission',
    },
    {
      question: 'Are all events free?',
      answer: 'Yes, all events are free! Our community is created to promote free events. Please check event details, as users can post and share events here. We do not promote or recommend paid events.',
    }
    ,
    {
      question: 'How to get notified when new events are posted?',
      answer:
        'Go to the Subscribe page and subscribe to our newsletter or our whatsapp group. You’ll receive updates whenever new events are posted.',
    },
  ];

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h2 className="text-3xl font-bold mb-8 animate-gradient-text text-center">
        Frequently Asked Questions
      </h2>
      <div className="bg-[#14181D] rounded-xl shadow-lg p-6">
        {faqs.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </div>
  );
};

export default FAQPage;